import { getDiff, SequenceChange, SequenceChangeType } from '@mangovoice/core'

export const KEYPAD_BUTTONS = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '*',
  '0',
  '#',
] as const
type KeypadButtonTuple = typeof KEYPAD_BUTTONS
type KeypadButton = KeypadButtonTuple[number]

export function isKeypadButton(value: string): value is KeypadButton {
  return KEYPAD_BUTTONS.includes(value as KeypadButton)
}

export const isPhoneNumber = (value: string) => {
  const cleanedValue = value.replace(/[^0-9A-Za-z]+/g, '')
  return /^[0-9]+$/g.test(cleanedValue)
}

export const getInsertionsAtOrBeforeIndex = (
  diff: SequenceChange[],
  index: number,
) => {
  const insertions = diff.filter(
    (change) =>
      change.type === SequenceChangeType.Insertion && change.index <= index,
  )

  return insertions.length
}

export const getDeletionsAtOrBeforeIndex = (
  diff: SequenceChange[],
  index: number,
) => {
  const deletions = diff.filter(
    (change) =>
      change.type === SequenceChangeType.Deletion && change.index <= index,
  )

  return deletions.length
}

export const getDiffSummaryLengthAtOrBeforeIndex = (
  original: string,
  modified: string,
  index: number,
) => {
  const diff = getDiff(original, modified)
  const insertions = getInsertionsAtOrBeforeIndex(diff, index)
  const deletions = getDeletionsAtOrBeforeIndex(diff, index - 1)

  return insertions - deletions
}

export { getDiff, SequenceChangeType }
export type { SequenceChange }
